<template>
  <AccountsExpansionPanelWrapper>
    <template #panels>
      <AccountsExpansionPanelRow
        v-for="account in accounts"
        :key="account.id"
        :account="account"
        @row-selected="selectedAccountId = $event"
        @get-accounts="$emit('get-accounts', $event)"
        @show-delete-dialog="showRemoveAccountDialog"
      >
        <template #account-type>
          <FbIcon />{{ $t("message.common.facebook") }}
        </template>
        <template #add-btn>
          <v-tooltip bottom :disabled="hasFacebookPages(account)">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <ui-button
                  color="primary"
                  outlined
                  icon="icon-plus"
                  :disabled="!hasFacebookPages(account)"
                  @click.stop="handleAddPages(account.id)"
                >
                  {{ $t("message.facebook.addPage") }}
                </ui-button>
              </div>
            </template>
            <span>{{ $t("message.facebook.noPagesToAdd") }}</span>
          </v-tooltip>
        </template>
        <template #items-list v-if="integratedPages(account).length > 0">
          <ExpansionListItem
            v-for="page in integratedPages(account)"
            :key="page.id"
            :item="page"
          >
            <template #actions>
              <ui-button
                @click="selectedPageId = page.id"
                icon="icon-trash"
                iconColor="red"
              >
                {{ $t("message.facebook.removePageAndFacilities") }}
              </ui-button>
            </template>
          </ExpansionListItem>
        </template>
      </AccountsExpansionPanelRow>
    </template>
    <template>
      <AlertDialog
        v-if="currentAlertDialog.visible"
        v-bind="alertDialogProps"
        @close="closeDialog"
        @confirm="currentAlertDialog.confirmAction"
      />
      <PageSelectDialog
        v-if="selectPageDialogVisible"
        :pages="facebookPages"
        @close="selectPageDialogVisible = false"
        @show-integration-confirm-dialog="showIntegrationConfirmAlert"
      />
      <AlertDialog
        v-if="showRemoveItemDialog"
        :title="$t('message.facebook.pageRemoveAlert.title')"
        :description="$t('message.facebook.pageRemoveAlert.description')"
        @close="showRemoveItemDialog = false"
        @confirm="$emit('delete-page', selectedPageId)"
      />
    </template>
  </AccountsExpansionPanelWrapper>
</template>

<script>
const DEFAULT_ALERT_DATA = Object.freeze({
  visible: false,
  title: "",
  description: "",
  confirmAction: null
});
import AccountsExpansionPanelWrapper from "@/components/ExpansionPanels/AccountsExpansionPanelWrapper.vue";
import AccountsExpansionPanelRow from "@/components/ExpansionPanels/AccountsExpansionPanelRow.vue";
import FbIcon from "@/components/ui/Icons/FbBlueIcon.vue";
import ExpansionListItem from "@/components/ExpansionPanels/ExpansionListItem.vue";
export default {
  name: "AccountsExpansionPanel",
  components: {
    AccountsExpansionPanelWrapper,
    AccountsExpansionPanelRow,
    FbIcon,
    ExpansionListItem,
    AlertDialog: () => import("@/components/FacebookAccounts/AlertDialog.vue"),
    PageSelectDialog: () =>
      import("@/components/FacebookAccounts/PageSelectDialog.vue")
  },
  props: {
    accounts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectPageDialogVisible: false,
      currentAlertDialog: DEFAULT_ALERT_DATA,
      selectedAccountId: null,
      showRemoveItemDialog: false,
      selectedPageId: null
    };
  },
  methods: {
    showIntegrationConfirmAlert() {
      this.currentAlertDialog = {
        visible: true,
        title: this.$t("message.facebook.enableIntegrationAlert.title"),
        description: this.$t(
          "message.facebook.enableIntegrationAlert.description"
        ),
        confirmBtnText: "message.facebook.goToMapConfiguration",
        cancelBtnText: "message.common.close",
        confirmAction: () => {
          this.currentAlertDialog.visible = false;
          this.$emit("get-accounts");
          this.$router.push({ name: "profile-map-settings" });
        }
      };
    },
    showRemoveAccountDialog(accountId) {
      this.currentAlertDialog = {
        visible: true,
        title: this.$t("message.facebook.accountRemoveAlert.title"),
        description: this.$t("message.facebook.accountRemoveAlert.description"),
        confirmAction: () => {
          this.deleteAccount(accountId);
        }
      };
    },
    closeDialog() {
      this.currentAlertDialog = DEFAULT_ALERT_DATA;
    },
    async deleteAccount(accountId) {
      this.$emit("delete-account", accountId);
      this.closeDialog();
    },
    integratedPages(account) {
      return account.facebook_pages.filter(page => page.is_integration_enabled);
    },
    hasFacebookPages(account) {
      return account.facebook_pages.length > 0;
    },
    handleAddPages(accountId) {
      this.selectedAccountId = accountId;
      this.selectPageDialogVisible = true;
    }
  },
  computed: {
    alertDialogProps() {
      return {
        title: this.currentAlertDialog.title,
        description: this.currentAlertDialog.description,
        cancelBtnText: this.currentAlertDialog.cancelBtnText,
        confirmBtnText: this.currentAlertDialog.confirmBtnText
      };
    },
    facebookPages() {
      if (!this.selectedAccountId) return [];
      return this.accounts.filter(
        account => account.id === this.selectedAccountId
      )[0].facebook_pages;
    }
  }
};
</script>
